const LINKS = [
  {
    label: "Sources",
    sub: "Manage active data sources",
    path: "/sources",
    icon: (
      <svg viewBox="0 0 20 20" fill="none" className="h-4 w-4 shrink-0" aria-hidden>
        <path
          d="M4 6h12M4 10h8M4 14h10"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    label: "Scanner",
    sub: "Discover assets on the network",
    path: "/scanner",
    icon: (
      <svg viewBox="0 0 20 20" fill="none" className="h-4 w-4 shrink-0" aria-hidden>
        <circle cx="9" cy="9" r="5" stroke="currentColor" strokeWidth="1.5" />
        <path d="M13 13l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    label: "Endpoints",
    sub: "Configure ingest receivers",
    path: "/endpoints",
    icon: (
      <svg viewBox="0 0 20 20" fill="none" className="h-4 w-4 shrink-0" aria-hidden>
        <path d="M7 3v3m6-3v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path
          d="M5 6h10v3a5 5 0 0 1-10 0V6Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path d="M10 14v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    label: "Artifacts",
    sub: "Download & verify deliveries",
    path: "/artifacts",
    icon: (
      <svg viewBox="0 0 20 20" fill="none" className="h-4 w-4 shrink-0" aria-hidden>
        <rect x="3" y="4" width="14" height="3" rx="1" stroke="currentColor" strokeWidth="1.5" />
        <path d="M4 7v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 11h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    label: "Audit Log",
    sub: "Review ingestion history",
    path: "/audit",
    icon: (
      <svg viewBox="0 0 20 20" fill="none" className="h-4 w-4 shrink-0" aria-hidden>
        <path d="M10 4v6l4 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
] as const;

interface QuickLinksProps {
  onNavigate: (path: string) => void;
}

export function QuickLinks({ onNavigate }: Readonly<QuickLinksProps>) {
  return (
    <div className="card">
      <div className="border-b border-rule px-5 py-3.5">
        <h2 className="text-[14px] font-semibold text-ink">Quick access</h2>
      </div>
      <div className="divide-y divide-rule">
        {LINKS.map(({ label, sub, path, icon }) => (
          <button
            key={path}
            onClick={() => onNavigate(path)}
            className="group flex w-full items-center gap-3 px-5 py-3 text-left transition-colors hover:bg-paper"
          >
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-datahub-gray-1500 text-ash transition-colors group-hover:bg-brand-50 group-hover:text-brand-600">
              {icon}
            </span>
            <div className="min-w-0 flex-1">
              <div className="text-[12.5px] font-semibold text-ink">{label}</div>
              <div className="truncate text-[10.5px] text-ash">{sub}</div>
            </div>
            <span className="shrink-0 text-ash transition-colors group-hover:text-brand-700">
              →
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
